module.exports = __webpack_public_path__ + "static/media/placeholder_1.1cc6a731.jpg";